import React, { Component } from 'react';
import config from './config.json';
import { getSysFieldid } from '@platform/api';

export default class Div extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		const { areaCode, fieldid, className, style, others } = this.props;

		let _config = {};

		if (areaCode && config[areaCode]) {
			_config = JSON.parse(JSON.stringify(config[areaCode]));
		}


		// 有些区域类型，不解析前缀
		//解析前缀的，没有前缀 也要加下划线(_)
		if (
			areaCode !== 'TotalRow' &&
			//areaCode !== 'SEARCH' && //NCC-118546业务代码查询区有多个区域标记的情况
			areaCode !== 'HEADER' && 
			areaCode !== 'BOTTOM'&& 
			areaCode !== 'TABS' && 
			areaCode != 'REPORT'&& 
			areaCode !== 'Flow' && 
			areaCode !== 'TipWin' && 
			areaCode !== 'Pagination'
		) {
			if (fieldid) {
				_config.fieldid = fieldid + '_' + _config.fieldid;
			} else {
				if(areaCode !== 'SEARCH'){ //查询区没有fieldid不加下划线
					_config.fieldid = '_' + _config.fieldid;
				}	
			}
		}


		_config.fieldid = getSysFieldid(_config.fieldid);


		// TotalArea 废弃掉，不再用, 可能业务已经使用，这里保留空div
		if (areaCode === 'TotalArea') {
			return (
				<div
					{...others}
					className={className || null}
					style={style || null}
				>{this.props.children}
				</div>
			);
		}

		// Title 行内
		if (areaCode === 'Title') {
			return (
				<span
					{...others}
					type="ncdiv"
					{..._config}
					className={className || null}
					style={style || null}
				>{this.props.children}
				</span>
			);
		}

		return (
			<div
				{...others}
				type="ncdiv"
				{..._config}
				className={className || null}
				style={style || null}
			>{this.props.children}
			</div>
		);
	}
}

Div.config = {
	HEADER: 'HEADER',
	FORM: 'FORM',
	TABLE: 'TABLE',
	SEARCH: 'SEARCH',
	REPORT: 'REPORT',
	TREE: 'TREE',
	MODAL: 'MODAL',
	TABS: 'TABS',
	BOTTOM: 'BOTTOM',
	Title: 'Title',
	Flow: 'Flow',
	TableCom: 'TableCom',
	TreeCom: 'TreeCom',
	TotalArea: 'TotalArea',
	TotalRow: 'TotalRow',
	Area: 'Area',
	List: 'List',
	Group: 'Group',
	ListItem: 'ListItem',
	TipWin: 'TipWin',
	Pagination: 'Pagination'
};
